var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"module__sound",class:{ 'is-active': _vm.isPlaying },on:{"click":function($event){return _vm.playAudio()}}},[_c('app-icon',{attrs:{"custom-class":"icon","icon":"sound","size-px":"24px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }